import { addQueryParamsToUrl } from "@/lib/course/utils/addQueryParamsToUrl";
import useExecEdDetailPageTest from "@/monarch/rules/execEdDetailPageTest/useExecEdDetailPageTest";

export function useModifiedSubmitUrl(postsubmiturl: string): string {
  const { data } = useExecEdDetailPageTest();
  const routeFlag = data?.routeFlag;

  if (!routeFlag || !postsubmiturl) {
    return postsubmiturl;
  }

  // Add "info." subdomain to the URL
  const url = new URL(postsubmiturl);
  url.hostname = `info.${url.hostname}`;

  // Add query parameters
  return addQueryParamsToUrl({
    url: url.toString(),
    includeUtmCampaign: false,
    organicUrl: null,
    extraQueryParams: {
      RVCreative: true,
      edx_lead: true,
      rv_source: "organic",
    },
  });
}
